import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { City } from '@app/entity/city';
import { AuthService, FederalSubjectsService } from '@app/core/services';
import { Partner, Veteran } from '@app/entity';

@Component({
  selector: 'app-magazine-page',
  templateUrl: './magazine-page.component.html',
  styleUrls: ['./magazine-page.component.scss']
})
export class MagazinePageComponent implements OnInit {
  cities: Observable<City[]> = this.federalSubjectsService.cities;
  currentCity: City;
  filter = {};

  tabs = [
    { name: 'Новости', path: 'news' },
    // { name: 'Праздники и памятные даты', path: 'events' },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private federalSubjectsService: FederalSubjectsService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
  }

  changeCity(city) {
    this.filter['city'] = city ? city.id : null;
    this.currentCity = city;
    this.router.navigate([], {
      queryParams: { ...( this.route && this.route.snapshot ? this.route.snapshot.queryParams : {}), ...this.filter },
      relativeTo: this.route
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/magazine/magazine-page/magazine-page.component.ts